angular.module('app').service('reportService', function ($http, $location, $routeParams, safeApply) {

  this.viewReport = function (page) {
    const _host = ($location.$$host == 'localhost') ? 'http://localhost:12001' : 'https://wizardgold.propertytax.io'
    const _url = `${_host}/report_preview/${$routeParams.user_id}/${$routeParams.user_token}/${$routeParams.prop_id}/${page}`
    window.open(_url, "_blank");
  }

});